const AUTH_CARD_TOP_OFFSET_CLASS = 'lg:mt-22';

export { AUTH_CARD_TOP_OFFSET_CLASS };
